/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconYourSettings from './nav-icon-your-settings.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconYourSettings {...validProps} />;
}
SvgComponent.iconName = 'navIconYourSettings';

export const NavIconYourSettingsIcon = svgIconWrapper(SvgComponent);
